import React from 'react';

import Section from '@hero/ui-kit/layout/Section';

import DefaultLayout from '../../../../components/DefaultLayout';
import DefaultErrorModal from '../../../../components/DefaultErrorModal';
import InlineLoader from '../../../../components/InlineLoader';
import Diagnostics from '../Diagnostics';
import Header from '../Header';
import useDeviceDetailsData from '../useDeviceDetailsData';

const DiagnosticsPage: React.FC = () => {
    const {
        deviceDetails,
        isLoading,
        hasError,
        errorMessage,
        isAppSupportAdminAdmin,
        isRefurbishmentAdmin
    } = useDeviceDetailsData();

    return (
        <DefaultLayout>
            {hasError && <DefaultErrorModal errorMessage={errorMessage} />}
            <Section
                subtheme={['regular', 'background']}
                paddingVertical="small"
                paddingHorizontal="regular"
            >
                <Header
                    isAppSupportAdminAdmin={isAppSupportAdminAdmin}
                    isRefurbishmentAdmin={isRefurbishmentAdmin}
                    externalSerial={deviceDetails.external_serial}
                    deviceId={deviceDetails.id}
                />
                {isLoading ? (
                    <InlineLoader />
                ) : (
                    <Diagnostics externalSerial={deviceDetails.external_serial} />
                )}
            </Section>
        </DefaultLayout>
    );
};

export default DiagnosticsPage;
